/* ------------------------------------------------------------------------------
@name: Footer
@description: Footer
--------------------------------------------------------------------------------- */

const Footer = (() => {
  // - footer
  const handleFooter = () => {
    // init controller
    const controller = new ScrollMagic.Controller();

    // fadeIn
    $(".section__fadeInFooter").each(function () {
      const ttl = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.8,
      })
        .setClassToggle(this, "fade-in")
        .addTo(controller);
    });
  };

  // - init
  const init = () => {
    handleFooter();
  };

  return {
    init,
  };
})();

export default Footer;
